import { Component, inject } from '@angular/core';
import { EditCompanyComponent } from '../../../../components/admin-dashboard-component/admin-companies-component/edit-company-component/edit-company-component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-edit-company',
  imports: [EditCompanyComponent],
  templateUrl: './edit-company.html',
  styleUrl: './edit-company.scss',
})
export class EditCompany {
  private route = inject(ActivatedRoute);
  companyId = this.route.snapshot.paramMap.get('id');
}
